import { t } from "i18next";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { Equipment, EquipmentById } from "../../../../types/types";
import { Input } from "../../../../ui/Input/Input";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";

const notificationsTypes = [
    {
        title: "work_without_human",
        type: "work_without_human",
        desc: "work_without_human_desc",
        value_text: 'value_for_notifications',
        defaultValue: 10 
    },
    {
        title: "work_with_wrong_card",
        type: "work_with_wrong_card",
        desc: "work_with_wrong_card_desc",
        value_text: 'value_for_notifications',
        defaultValue: 10 
    },
    {
        title: "idle_more_than",
        type: "idle_more_than",
        desc: "idle_more_than_desc",
        value_text: 'value_for_notifications_in_minutes',
        defaultValue: 15 
    },
    {
        title: "equipment_turned_off",
        type: "equipment_turned_off",
        desc: "equipment_turned_off_desc",
        value_text: 'value_for_notifications',
        defaultValue: 10 
    },
    {
        title: "equipment_in_repair",
        type: "equipment_in_repair",
        desc: "equipment_in_repair_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "equipment_in_worked",
        type: "equipment_in_worked",
        desc: "equipment_in_worked_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "equipment_repair_started",
        type: "equipment_repair_started",
        desc: "equipment_repair_started_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "equipment_repair_finished",
        type: "equipment_repair_finished",
        desc: "equipment_repair_finished_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "person_start_work_on_equipment",
        type: "person_start_work_on_equipment",
        desc: "person_start_work_on_equipment_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "person_finish_work_on_equipment",
        type: "person_finish_work_on_equipment",
        desc: "person_finish_work_on_equipment_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "short_statistic_by_shift",
        type: "short_statistic_by_shift",
        desc: "short_statistic_by_shift_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "problems_with_network",
        type: "problems_with_network",
        desc: "problems_with_network_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    },
    {
        title: "parameters_violation",
        type: "parameters_violation",
        desc: "parameters_violation_desc",
        value_text: 'value_for_notifications',
        defaultValue: 0 
    }
]

export const Notifications = ({equipment}:{equipment:Equipment}) => {
    function handleChange(e: ChangeEvent<HTMLInputElement>, type: string) {

    }

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background max-w-[1008px]">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('notifications')}</span>
        </div>
      </div>
      <div className="relative flex pb-10 h-full w-full overflow-hidden">
        <div className="px-6 flex flex-col gap-2 w-full">
            {
                notificationsTypes.map(n =>(
                    <div key={n.type} className="flex flex-col w-full p-4 border border-border text-sm rounded">
                        <div className="font-medium text-base">{t(n.title)}</div>
                        <div>{t(n.desc)}</div>
                        <div className="flex w-full justify-between items-center">
                            <div>{t(n.value_text)}</div>
                            <div>
                            <Input 
                                className="h-6 max-w-[100px]"
                                placeholder={t("equipment_search")}
                                onChange={(e) => handleChange(e, n.type)}
                                value={n.defaultValue}
                                autoComplete="off"
                                width="100%" 
                            />
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
      </div>
    </div>
  )
};
